import GraphqlWsClient from './graphql-ws-client.js';

export default class SubscriptionService {
  constructor(graphqlHostEndpoint, graphqlWsEndpoint, token, lazyGraphqlWsConnection = false) {
    this.graphqlHostEndpoint = graphqlHostEndpoint;
    this.token = token;
    this.lazyGraphqlWsConnection = lazyGraphqlWsConnection;
    this.graphqlWsEndpoint = graphqlWsEndpoint;

    this.graphqlWsClient = new GraphqlWsClient(this.buildGraphqlWsEndpoint(), {
      reconnect: true,
      reconnectionAttempts: 5,
      timeout: 90000, // because heartbeats comes from AppSync by 60s
      lazy: this.lazyGraphqlWsConnection,
    });
  }

  /**
   * @param {string} subscriptionQuery
   * @param {import('../../types/graphql-ws-client').GraphqlSubscriber} subscriber
   */
  subscribeToGraphql(subscriptionQuery, subscriber) {
    return this.graphqlWsClient
      .request({
        data: JSON.stringify({ query: subscriptionQuery }),
        extensions: { authorization: { Authorization: `Bearer ${this.token}`, host: this.graphqlHostEndpoint } },
      })
      .subscribe(subscriber);
  }

  buildGraphqlWsEndpoint() {
    const header = JSON.stringify({
      host: this.graphqlHostEndpoint,
      Authorization: `Bearer ${this.token}`,
    });
    const base64Header = btoa(header);

    return `${this.graphqlWsEndpoint}?header=${base64Header}&payload=e30=`;
  }
}
